@reference "@glow/tailwind-config/reference.css";

.row {
  @apply grid;
  @apply gap-4;
  @apply w-full;
  @apply mb-4;
}
.form.max-2xl {
  @apply max-w-2xl;
}
.form.max-3xl {
  @apply max-w-3xl;
}
.form.max-4xl {
  @apply max-w-4xl;
}
.form.max-5xl {
  /* 1500px matches modal-base size large in width */
  @apply max-w-[1500px];
}

.row[data-columns="1"] {
  @apply grid-cols-1;
}
.row[data-columns="2"] {
  @apply grid-cols-2;
}
.row[data-columns="3"] {
  @apply grid-cols-3;
}
.row[data-columns="4"] {
  @apply grid-cols-4;
}
.row[data-columns="5"] {
  @apply grid-cols-5;
}

.section {
  @apply first:mt-0;
  @apply mt-6;
}

.formGrid .section {
  @apply mt-0;
}

.formGrid {
  @apply grid;
  @apply gap-8;
}

.formGrid.columns-2 {
  @apply grid-cols-1;
  @apply xl:grid-cols-2;
}

.formGrid.columns-3 {
  @apply grid-cols-1;
  @apply xl:grid-cols-3;
}
